import React from 'react';
import Image from 'next/image';
import { INodeMedia } from '../../lib/types';

import styles from './FeaturedImage.module.scss';

interface FeaturedImageProps {
  featuredImage: INodeMedia;
  postTitle: string;
  height: number;
  width: number;
}

const FeaturedImage = (props: FeaturedImageProps) => {
  const { featuredImage, postTitle, width, height } = props;

  return (
    <div className={styles['featured-image']}>
      {featuredImage && featuredImage.node && featuredImage.node.sourceUrl ? (
        <Image
          src={featuredImage.node.sourceUrl}
          alt={featuredImage.node.altText || postTitle}
          objectFit="cover"
          objectPosition="center"
          loading="lazy"
          width={width}
          height={height}
          priority={false}
          quality={60}
          sizes={featuredImage.node.sizes}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default FeaturedImage;
